import { Component, Input } from '@angular/core';
import type { SimpleChanges } from '@angular/core';
import { Chart } from 'chart.js';
import { debug } from 'console';

@Component({
  selector: 'app-common-chart',
  templateUrl: './common-chart.component.html',
  styleUrl: './common-chart.component.scss'
,  standalone: false
})
export class CommonChartComponent {

  @Input() chartId: string;
  @Input() chartType: any;
  @Input() labels: any[];
  @Input() datasets: any[];

  // ngOnInit() {
  //   this.renderChart();
  // }

  // renderChart() {
  //   const myChart = new Chart(this.chartId, {
  //     type: this.chartType,
  //     data: {
  //       labels: this.labels,
  //       datasets: this.datasets
  //     },
  //     options: {
  //       responsive: true,
  //       plugins: {
  //         legend: {
  //           display: true,
  //           //position: 'top',
  //           labels: {
  //             font: {
  //               size: 13,
  //               family: 'Open Sans, sans-serif',
  //             },
  //             color: 'black'
  //           }
  //         },
  //         tooltip: {
  //           enabled: true,
  //           mode: 'index',
  //           intersect: false,
  //         },
  //         datalabels: {
  //           anchor: 'end',
  //           align: 'end',
  //           font: {
  //             size: 14,
  //             family: 'Open Sans, sans-serif',
  //             weight: 'bold'
  //           },
  //           color: 'black'
  //         }
  //       },
  //       scales: {
  //         x: {
  //           stacked: false,
  //           beginAtZero: true,
  //           ticks: {
  //             display: true,
  //             font: {
  //               size: 13,
  //               family: 'Open Sans, sans-serif'
  //             },
  //             color: 'black'
  //           },
  //           grid: {
  //             display: false
  //           }
  //         },
  //         y: {
  //           stacked: false,
  //           beginAtZero: true,
  //           ticks: {
  //             stepSize: 1,
  //             font: {
  //               size: 13,
  //               family: 'Open Sans, sans-serif'
  //             },
  //             color: 'black'
  //           },
  //           grid: {
  //             display: false
  //           }
  //         }
  //       }
  //     }
  //   });
  // }
  ngOnChanges(changes: SimpleChanges) {
    if (changes.labels || changes.datasets) {
      if (this.chartType === 'pie') {
        this.renderPieChart();
      } else {
        this.renderChart(false);
      }
    }
  }

  renderChart(stackedBar: boolean = false) {
    const ctx = document.getElementById(this.chartId) as HTMLCanvasElement;
    if (ctx) {
      if(this.renderNoDataContext(ctx)){
        return;
      }
      const myChart = new Chart(ctx, {
        type: this.chartType,
        data: {
          labels: this.labels,
          datasets: this.datasets.map(dataset => ({
            ...dataset,
            barThickness: 30, // Adjust this value to control the bar width
            maxBarThickness: 30 // Adjust this value to control the maximum bar width
          }))
        },
        options: {
          responsive: true,
          plugins: {
            legend: {
              display: true,
              position: 'bottom', // Position the legend at the bottom
              align: 'center', // Center align the legend
              labels: {
                font: {
                  size: 13,
                  family: 'Open Sans, sans-serif',
                },
                color: 'black'
              }
            },
            tooltip: {
              enabled: true,
              mode: 'index',
              intersect: false,
            },
            datalabels: {
              anchor: 'end',
              align: 'end',
              font: {
                size: 14,
                family: 'Open Sans, sans-serif',
                weight: 'bold'
              },
              color: 'black'
            }
          },
          scales: {
            x: {
              stacked: stackedBar,
              beginAtZero: true,
              ticks: {
                display: true,
                font: {
                  size: 12,
                  family: 'Open Sans, sans-serif'
                },
                color: 'black',
                callback: function(value) {
                  var label = this.getLabelForValue(value);
                  return stackedBar? label?.split(' ').flat():label // Split the label into words if stackedBar is true
               },
              },
              grid: {
                display: false
              },
              barPercentage: 2.8, // Adjust this value to control the bar width
              categoryPercentage: 2 // Adjust this value to control the spacing between bars
            },
            y: {
              stacked: false,
              beginAtZero: true,
              ticks: {
                stepSize: 1,
                font: {
                  size: 13,
                  family: 'Open Sans, sans-serif'
                },
                color: 'black'
              },
              grid: {
                display: false
              }
            }
          }
        }
      });
    }
  }
  renderPieChart() {
    const ctx = document.getElementById(this.chartId) as HTMLCanvasElement;
    if (ctx) {
      if(this.renderNoDataContext(ctx)){
        return;
      }
      const options = {
        responsive: true,
        plugins: {
          legend: {
            display: true,
            position: 'bottom', // Position the legend at the bottom
            align: 'center', // Center align the legend
            fullSize: true,
            labels: {
              font: {
                size: 13,
                family: 'Open Sans, sans-serif',
              },
              color: 'black',
              padding: 20, // Add padding to avoid collision with x-axis labels
              boxWidth: 20,
            }
          },
          tooltip: {
            enabled: true,
            mode: 'index',
            intersect: false,
          },
          datalabels: {
            anchor: 'end',
            align: 'end',
            font: {
              size: 14,
              family: 'Open Sans, sans-serif',
              weight: 'bold'
            },
            color: 'black'
          }
        }
      };
      // Add scales only if the chart type is not 'pie'
      if (this.chartType !== 'pie') {
        options['scales'] = {
          x: {
            stacked: false,
            beginAtZero: true,
            ticks: {
              display: true,
              font: {
                size: 13,
                family: 'Open Sans, sans-serif'
              },
              color: 'black'
            },
            grid: {
              display: false
            },
            barPercentage: 2.8, // Adjust this value to control the bar width
            categoryPercentage: 2.8 // Adjust this value to control the spacing between bars
          },
          y: {
            stacked: false,
            beginAtZero: true,
            ticks: {
              stepSize: 1,
              font: {
                size: 13,
                family: 'Open Sans, sans-serif'
              },
              color: 'black'
            },
            grid: {
              display: false
            }
          }
        };
      }

      const myChart = new Chart(ctx, {
        type: this.chartType,
        data: {
          labels: this.labels,
          datasets: this.datasets.map(dataset => ({
            ...dataset,
            barThickness: this.chartType === 'pie' ? undefined : 50, // Adjust this value to control the bar width
            maxBarThickness: this.chartType === 'pie' ? undefined : 50 // Adjust this value to control the maximum bar width
          }))
        },
        options: options
      });
    }
  }
  
renderNoDataContext(ctx:any):boolean {
  if (!this.datasets || 
    this.datasets.length === 0 || 
    !this.datasets.some(dataset => dataset.data && dataset.data.length > 0 
    && dataset.data.some(val => val > 0))) 
    {
  const noDataCtx = ctx.getContext('2d');
  if (noDataCtx) {
    noDataCtx.clearRect(0, 0, ctx.width, ctx.height); // Clear the canvas
    noDataCtx.font = '18px Open Sans, sans-serif';
    noDataCtx.fillStyle = 'black';
    noDataCtx.textAlign = 'center';
    noDataCtx.fillText('No data to display', ctx.width / 2, ctx.height / 2);
  }
  return true; // Return true to indicate that no data is available
}
  return false; // Return false to indicate that data is available
}

}
